import React from 'react'
import PlayerInit from './PlayerInit'

export default function Player(props) {
    const {
        videoUrl,
        className = '',
        style = {},
        muted = false,
        autoplay = false,
        poster,
        preload,
        playerId = 'logixPlayer',
        onPlayerReady,
        playBackdata,
        playVideoInLoop,
        isActive = true,
        activeIndex
        
    } = props
    return (
        <div id="playerDiv" className={className} style={style}>
            <div
                id={playerId}
                style={{ width: '100%', height: '100%', position: 'relative' }}
            >
                <PlayerInit
                    videoUrl={videoUrl}
                    className={className}
                    style={style}
                    muted={muted}
                    autoplay={autoplay}
                    poster={poster}
                    preload={preload}
                    playerId={playerId}
                    onPlayerReady={onPlayerReady}
                    playBackdata={playBackdata}
                    playVideoInLoop={playVideoInLoop}
                    isActive={isActive}
                    activeIndex={activeIndex}
                />
            </div>
        </div>
    )
}
